import { render, staticRenderFns } from "./treatyPop.vue?vue&type=template&id=218b3f2c&scoped=true&"
import script from "./treatyPop.vue?vue&type=script&lang=js&"
export * from "./treatyPop.vue?vue&type=script&lang=js&"
import style0 from "./treatyPop.vue?vue&type=style&index=0&id=218b3f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b3f2c",
  null
  
)

export default component.exports